<template>
  <div>
    <BBModal
      width="425px"
      class-button="btn btn-link btn-highlight btn-sm d-flex align-items-center"
      :is-button="false"
    >
      <slot />
      <template slot="title">
        <div class="title1">
          Submit Order
        </div>
        <div class="title2">
          Select Saved Design
        </div>
      </template>
      <template slot="content">
        <div>
          <div class="description">
            To submit a new order, choose from a saved design and review it
            before proceeding.
          </div>
          <div id="wrapperDesignGridSubmit" @scroll.passive="onScroll">
            <div id="createNewDesign">
              <router-link
                class="btn btn-outline-primary"
                tag="button"
                :to="{
                  name: 'landingPageCategories'
                }"
              >
                Create a new design
              </router-link>
            </div>
            <div id="designGridSubmit">
              <SavedDesignSimple
                :design="design"
                v-for="design in designs"
                :key="design._id"
                :show-actions="false"
              />
            </div>
          </div>
        </div>
      </template>
    </BBModal>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import SavedDesignSimple from './SavedDesignSimple'

const oauthStore = namespace('oauthStore')
const designStore = namespace('designStore')

@Component({
  components: { SavedDesignSimple }
})
export default class pickADealer2 extends Vue {
  @oauthStore.Getter('userId') userId
  @designStore.Action('fetchDesigns') actionFetchItems
  @designStore.Action('fetchMoreDesigns') actionFetchMoreItems

  @designStore.Getter('getDesigns') designs
  perPage = 10
  page = 1
  loadMore = true

  /**
   * Hook: mounted
   * Initialize the pre data. It dispatch multiple store actions to each api service
   */
  mounted() {
    this.actionFetchItems({
      userId: this.userId,
      perPage: this.perPage,
      page: this.page++
    })
  }

  onScroll(e) {
    const scrollTop = e.target.scrollTop
    if (this.loadMore && e.target.scrollHeight - 805 <= scrollTop) {
      this.loadMore = false
      this.actionFetchMoreItems({
        userId: this.userId,
        perPage: this.perPage,
        page: this.page++
      }).then(data => {
        if (data.length) {
          this.loadMore = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title1,
.title2 {
  color: #ffffff;
  font-family: $secondary-font;
  font-size: 22px;
  letter-spacing: 0.79px;
}
.title1 {
  font-weight: bold;
}
.bb-modal-component {
  /deep/ {
    .card-body {
      background: white;
      padding-bottom: 0;
      padding-top: 0;
    }
  }
}
.description {
  background: #f7f7f7;
  color: #0f0f0f;
  font-size: rem(16px);
  letter-spacing: 0.5px;
  line-height: 20px;
  margin: 0 -45px;
  padding: 15px 45px 22px;
}

#createNewDesign {
  margin: 0 8.5px;
  text-align: center;
  button {
    border-width: 1px;
    width: 100%;
  }
}
#wrapperDesignGridSubmit {
  overflow-y: scroll;
  margin: 15px -14px 0 -8.5px;
  max-height: 410px;
}

#close {
  cursor: pointer;
  padding-bottom: 40px;
  padding-top: 40px;
  text-decoration: underline;
}

.bb-modal-component {
  /deep/ {
    .p-0 {
      border-radius: 4px;
    }
    .card-footer {
      border: none;
      box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.29);
    }
  }
}
</style>
